import {createHotelDetailsQueryOptions} from '@/api/hoteldetails';
import * as bffSupportQueries from '@/modules/common/queries/bffSupport';

export const getHotelDetailsFetchMethod = ({
  isHotelContentApiFeatureOn,
}: {
  isHotelContentApiFeatureOn: boolean;
}) =>
  isHotelContentApiFeatureOn
    ? (hotelId: string) => bffSupportQueries.singleHotel(hotelId)
    : createHotelDetailsQueryOptions;
